<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility" tabindex="-1" pplAutoFocusHeader>Payroll Resurrect</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-timesheet-filter [filterFields]="fields"
                        (searchEvent)="onSearch($event)"></ppl-timesheet-filter>
                    <p class="pl-2"> <span class="error-message1" [attr.aria-label]="'Required'">*</span> At least one out of the following fields
                        should be populated: <b>Consumer Name</b>, <b>Consumer PPL ID</b>, <b>Provider Name</b>,
                        <b>Provider PPL ID</b>.
                    </p>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Resurrect</strong> action, please select the applicable timesheet.</li>
                            <li>The <strong>Resurrect All</strong> action will update all timesheets that match the
                                search criteria OR all the selected timesheets.</li>
                        </ul>
                    </div>
                </div>
                <div class="table-style">
                    @if(timesheets.length > 0) {
                    <ppl-list-table [actionButtons]="actionButtons" (actionInvoked)="gridAction($event)" [cols]="cols"
                        [customDataLoaded]="true" [data]="timesheets" [disableSearch]="true" [disableSort]="true"
                        [enableActions]="false" [from]="'timesheet'" [enablePageActions]="true" [gridTitle]="false"
                        [listButton]="buttons" [loadPage]="true" [pagination]="true" rowDataAccessibilityKey="service_date"
                        (rowDetailEventTs)="rowClicked($event)" [showCustomSearch]="false"
                        [timesheetFor]="'pendedTimesheet'">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>

<div class="filter-panel">
    <ng-template #timesheetResurrectDialog let-cancel="cancel">
        <ppl-timesheet-adjust-void-entry [timesheetData]="timesheetData" [searchParams]="appliedFilters"
            [actionData]="selectedAction" (timesheetAdjustedOrVoided)="timesheetResurrected($event)"
            [source]="'resurrect'"></ppl-timesheet-adjust-void-entry>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #deniedDialog let-cancel="cancel">
        <ppl-timesheet-staff-deniedreasons [deniedData]="deniedData"></ppl-timesheet-staff-deniedreasons>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #searchFilterWarningDialog let-cancel="cancel">
        <p> At least one out of the following fields should be populated: Consumer Name, Consumer PPL ID, Provider Name,
            Provider PPL ID</p>
    </ng-template>
</div>